import type { ExerciseMediaType, ExerciseUsageCategory } from './api/types';

/** Stable values stored by the service, with the wording shown wherever the shared exercise library is used. */
export const EXERCISE_USAGE_CATEGORIES: readonly { value: ExerciseUsageCategory; label: string }[] = [
  { value: 'rehab', label: 'Rehabilitation' },
  { value: 'gym', label: 'Gym / strength' },
  { value: 'warm_up', label: 'Warm-up' },
  { value: 'mobility', label: 'Mobility' },
  { value: 'conditioning', label: 'Conditioning' },
  { value: 'recovery', label: 'Recovery' },
  { value: 'testing', label: 'Testing / assessment' },
  { value: 'other', label: 'Other' },
];

export const EXERCISE_MEDIA_TYPES: readonly { value: ExerciseMediaType; label: string }[] = [
  { value: '', label: 'No media' },
  { value: 'gif', label: 'GIF animation' },
  { value: 'video', label: 'Video' },
  { value: 'link', label: 'Instruction webpage' },
];

export const exerciseUsageLabel = (value: ExerciseUsageCategory | ''): string => EXERCISE_USAGE_CATEGORIES.find((option) => option.value === value)?.label ?? 'Other';
export const exerciseMediaLabel = (value: ExerciseMediaType): string => EXERCISE_MEDIA_TYPES.find((option) => option.value === value)?.label ?? 'No media';
